import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import blogImg from "../assets/collage3.png";
import emiImg from "../assets/collage4.png";
import branchImg from "../assets/collage2.png";
import loanImg from "../assets/collage6.png";
import contactImg from "../assets/collage5.png";

export default function ServiceGrid() {
  return (
    <div className="py-3">
      <style>
        {`
          /* 📱 For mobile screens */
          @media (max-width: 768px) {
            .service-img {
              min-height: 120px !important;
            }
            .service-small {
              min-height: 80px !important;
            }
            .service-text {
              font-size: 0.9rem !important;
            }
            .service-btn {
              padding: 3px 8px !important;
              font-size: 0.7rem !important;
            }
          }
        `}
      </style>

      <div className="row g-3 align-items-stretch">
        {/* Left Large Image */}
        <div className="col-6 col-md-3 p-1 d-flex">
          <div
            className="service-img"
            style={{
              position: "relative",
              borderRadius: "12px",
              overflow: "hidden",
              flex: 1,
              height: "100%",
              minHeight: "220px",
            }}
          >
            <img
              src={blogImg}
              alt="Blogs"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "12px",
              }}
            />
            <div
              className="service-text"
              style={{
                position: "absolute",
                bottom: "10px",
                left: "10px",
                color: "#fff",
                fontWeight: "600",
                fontSize: "1.1rem",
              }}
            >
              Explore Our <br /> Latest Blogs
            </div>
          </div>
        </div>

        {/* Middle Left Two Boxes */}
        <div className="col-6 col-md-3 p-1 d-flex flex-column justify-content-between">
          <div
            className="mb-2 flex-fill service-small"
            style={{
              position: "relative",
              borderRadius: "12px",
              overflow: "hidden",
              flex: 1,
              minHeight: "105px",
            }}
          >
            <img
              src={emiImg}
              alt="EMI"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "12px",
              }}
            />
          </div>

          <div
            className="flex-fill service-small"
            style={{
              position: "relative",
              borderRadius: "12px",
              overflow: "hidden",
              flex: 1,
              minHeight: "105px",
            }}
          >
            <img
              src={branchImg}
              alt="Branch"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "12px",
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: "10px",
                left: "10px",
              }}
            >
              <button
                className="service-btn"
                style={{
                  backgroundColor: "#f8a541",
                  border: "none",
                  color: "#fff",
                  borderRadius: "5px",
                  padding: "4px 10px",
                  fontWeight: "600",
                  fontSize: "0.8rem",
                }}
              >
                LOCATE US
              </button>
            </div>
          </div>
        </div>

        {/* Middle Right - Instant Loan */}
        <div className="col-6 col-md-3 p-1 d-flex">
          <div
            className="service-img"
            style={{
              position: "relative",
              borderRadius: "12px",
              overflow: "hidden",
              flex: 1,
              minHeight: "220px",
            }}
          >
            <img
              src={loanImg}
              alt="Loan"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "12px",
              }}
            />
            <div
              className="p-4 service-text"
              style={{
                position: "absolute",
                top: "10px",
                left: "0",
                right: "0",
                color: "#fff",
                fontWeight: "700",
                fontSize: "1.4rem",
                textShadow: "0 2px 4px rgba(0,0,0,0.5)",
              }}
            >
              Instant Loan With
              <br /> No Hidden Charges
            </div>
          </div>
        </div>

        {/* Rightmost - Contact Us */}
        <div className="col-6 col-md-3 p-1 d-flex">
          <div
            className="service-img"
            style={{
              position: "relative",
              borderRadius: "12px",
              overflow: "hidden",
              flex: 1,
              minHeight: "220px",
            }}
          >
            <img
              src={contactImg}
              alt="Contact"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "12px",
              }}
            />
            <div
              className="p-4 service-text"
              style={{
                position: "absolute",
                top: "10px",
                left: "10px",
                color: "#fff",
                fontWeight: "600",
                fontSize: "1.5rem",
              }}
            >
              For More Services
              <br />
              and Queries
            </div>
            <div
              style={{
                position: "absolute",
                bottom: "10px",
                left: "10px",
              }}
            >
              <button
                className="service-btn"
                style={{
                  backgroundColor: "#f8a541",
                  border: "none",
                  color: "#fff",
                  borderRadius: "5px",
                  padding: "6px 10px",
                  fontWeight: "600",
                  fontSize: "0.8rem",
                }}
              >
                CONTACT US
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
